/* eslint @typescript-eslint/explicit-function-return-type: off */

import React from 'react';
import PropTypes from 'prop-types';

const Body = ({ children }) => <div className='box-body'>{children}</div>;

Body.propTypes = {
  children: PropTypes.node,
};

export default Body;
